export default __webpack_public_path__ + "static/hero-751f9c5dd7cb6bfcf185cb3b9a3be023.jpg";